import { useTranslator } from "@eo-locale/react";

import { useRouter } from "next/router";

import { useAppSelector } from "@/redux/store/hooks";
import {
  Box,
  Button,
  FiShare2,
  Flex,
  Heading,
  HTMLWrapper,
  SocialShare,
  Tag,
  useBreakpointValue
} from "@/storybook-components";

function About({ closeSideBar }: any) {
  const { query } = useRouter();
  const { translate } = useTranslator();

  const { projectId, brainstormerId } = query;
  const { baseUrl } = useAppSelector((state) => state.adapter.adapter);
  const { name, description, tagList } = useAppSelector(
    (state) => state.brainstormers.brainstormer
  );
  const { disableSocialMediaSharing } = useAppSelector(
    (state) => state.settings.settings
  );

  const isMobile = useBreakpointValue({ base: true, lg: false }) || false;

  return (
    <Flex direction="column" gap={6} flex={1}>
      <Heading as="h1" fontWeight="bold" fontSize="2xl" color="gray.900">
        {name}
      </Heading>
      <HTMLWrapper
        isFullWidth
        fontSize="sm"
        color="gray.800"
        html={description}
      />

      {(tagList.length > 0 || !disableSocialMediaSharing) && (
        <Flex direction="column" gap={4}>
          {tagList.length > 0 && (
            <Flex gap={2} wrap="wrap">
              {tagList.map((tag: string) => (
                <Tag
                  key={tag}
                  fontSize="sm"
                  variant="solid"
                  bgColor="white"
                  color="gray.800"
                  colorScheme="whiteAlpha"
                  style={{ direction: "rtl" }}
                >
                  {tag}
                </Tag>
              ))}
            </Flex>
          )}
          {!disableSocialMediaSharing && (
            <Box>
              <SocialShare
                title={name}
                placement="auto"
                shareUrl={`${baseUrl}/${projectId}/brainstormers/${brainstormerId}`}
                trigger={
                  <Button
                    px={3}
                    w="auto"
                    size="lg"
                    variant="tertiary"
                    bgColor="transparent"
                    leftIcon={<FiShare2 />}
                  >
                    {translate("common.share")}
                  </Button>
                }
              />
            </Box>
          )}
        </Flex>
      )}
      {isMobile && (
        <Button
          variant="primary"
          mt="auto"
          size="lg"
          w="full"
          onClick={closeSideBar}
        >
          {translate("brainstormers.viewFeed")}
        </Button>
      )}
    </Flex>
  );
}

export default About;
